import type { RouteObject } from 'react-router';
import { ComplianceOverviewPage } from './pages/ComplianceOverviewPage';

export const COMPLIANCE_ROUTES: RouteObject[] = [{ path: 'compliance', element: <ComplianceOverviewPage /> }];
